<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader>Fornecedores sugeridos</v-subheader>
        <v-divider/>
        <v-list class="rounded-card">
          <template v-for="(fornecedor, index) in requisicao.fornecedores">
            <v-list-item :key="fornecedor.id">
              <v-list-item-content>
                <v-list-item-title>
                  <px-span-tooltip
                    v-if="fornecedor.codigoInterno"
                    bottom
                    text-class="caption"
                    :text="`(${fornecedor.codigoInterno})`"
                    tooltip="Código interno do fornecedor"/>
                  {{ fornecedor.pessoa.nome }}
                  <px-popover-fornecedor :fornecedor="fornecedor" show-score />
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ fornecedor.pessoa.cnpj | cnpj }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index !== (requisicao.fornecedores.length - 1)"
                       :key="`v-div-f${fornecedor.id}`"/>
          </template>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    mapFornecedores() {
      this.requisicao.fornecedores = this.requisicao.fornecedores.map(f => this.buildFornecedor(f));
    },
    buildFornecedor(fornecedor) {
      const detalheFornecedor = this.requisicao.detalhesFornecedores
        .find(detalhe => detalhe.fornecedor.id === fornecedor.id);
      if (!detalheFornecedor) {
        return {
          ...fornecedor,
        };
      }
      return {
        ...fornecedor,
        codigoInterno: detalheFornecedor.codigoInterno,
      };
    },
  },
  created() {
    this.mapFornecedores();
  },
};
</script>
